/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ConversationType;

(function (ConversationType) {
  ConversationType["AI"] = "ai";
  ConversationType["AGENT"] = "agent";
})(ConversationType || (ConversationType = {}));